export default "/packs/images/Ali~bcbe487b62b582e9b7f8e5c19123423e.jpg";